import 'whatwg-fetch';
import { defaultsDeep, get, set } from 'lodash';

import storage from '@lib/services/storageService';
import configService from '@lib/services/configService';
import StoreInstance from '@lib/utils/StoreInstance';
import signOut from '@lib/actions/signOut';

/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
function parseJSON(response) {
  return response.json();
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  if (response.status === 401) {
    StoreInstance.store.dispatch(signOut({}));
  }
  throw response;
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} endpoint  The endpoint we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default function request(endpoint, options) {
  const url = `${configService.getApiBasePath()}${endpoint}`;

  // configure access token
  const token = get(options, 'token') || storage.getToken() || '';
  const defaults = {
    credentials: 'include',
    headers: {
      'x-access-token': token,
    },
  };

  // use json for put/post
  if (options && options.body && /put|post/i.test(options.method) && !/binary/i.test(endpoint)) {
    defaults.headers['Content-Type'] = 'application/json';
    set(options, 'body', JSON.stringify(options.body));
  }

  return fetch(url, defaultsDeep({}, options, defaults))
    .then(checkStatus)
    .then(parseJSON);
}
